export default "__VITE_ASSET__DQW7yPKB__"